import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import getEnabledRoutes from './getEnabledRoutes';
import { useOnErrorHandler } from '../../../common';

function useGetEnabledRoutes({ routeType }) {
  const { username: id_clouder } = useSelector((store) => store.auth);

  const query = useQuery({
    queryKey: ['getEnabledRoutes', { id_clouder, routeType }],
    queryFn: () => getEnabledRoutes({ id_clouder, routeType }),
    enabled: !!id_clouder && !!routeType,
    staleTime: 5000,
  });

  useOnErrorHandler({ query });

  return query;
}

export default useGetEnabledRoutes;
